<template>
  <b-icon class="sidebar-ctl" icon="text-indent-right" v-if="isFloatingSidebar" @click="handleOnClickMenuIcon"></b-icon>
</template>

<script>
import { mapActions } from "vuex";
import { CHANGE_EXPAND_MENU } from "@/store/actions";
import { BIcon } from "bootstrap-vue";

export default {
  name: "ExpandMenuIcon",
  components: { BIcon },
  computed: {
    isFloatingSidebar() {
      if(this.$mq === 'xl' || this.$mq === 'xs') {
        return false;
      }
      return true;
    }
  },
  methods: {
    ...mapActions("common", { changeExpandMenu: CHANGE_EXPAND_MENU }),
    handleOnClickMenuIcon() {
      this.changeExpandMenu({ expand: true });
    },

  },
};
</script>

<style scoped>
.sidebar-ctl {
  display: block;
  position: absolute;
  left: 16px;
  top: 16px;
  width: 25px;
  height: 25px;
  color: #005fc4;
  z-index: 1;
  cursor: pointer;
}
</style>
